module.exports = __webpack_public_path__ + "static/img/set-out.153fca94.png";